import React from 'react';
import styled from 'styled-components';
import fn from '../../helpers/fn';

export default fn(__filename, styled.span`
  position: relative;
  display: flex;

  ${({ wrap }) => wrap && `
    flex-wrap: wrap;
  `}

  ${({ fill }) => fill && `
    flex: 1;
  `}

  ${({ width }) => width && `
    width: ${width};
  `}

  ${({ height }) => height && `
    height: ${height};
  `}

  ${({ vertical, horizontal, valign }) => !vertical && horizontal && valign && `
    align-items: ${valign};
  `}
  ${({ vertical, horizontal, halign }) => !vertical && horizontal && halign && `
    justify-content: ${halign};
  `}
  ${({ vertical, horizontal, valign }) => vertical && !horizontal && valign && `
    justify-content: ${valign};
  `}
  ${({ vertical, horizontal, halign }) => vertical && !horizontal && halign && `
    align-items: ${halign};
  `}

  ${({ vertical, horizontal }) => vertical && !horizontal && `
    flex-direction: column;
  `}
  ${({ vertical, horizontal }) => !vertical && horizontal && `
    flex-direction: row;
  `}
`.withComponent(({
  wrap, vertical, horizontal, halign, valign, height, fill, // strip
  ...props
}) => <span {...props} />));



// WEBPACK FOOTER //
// ./src/components/blocks/Flex.js